import React from "react";
import { useTranslation, Trans } from "react-i18next";
import Button from '../Button'
import book from '../../img/Home/book.png'
import Fade from 'react-reveal/Fade'
import CountUp from 'react-countup';

import gif from '../../img/Home/2.gif'

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative rounded-b-[80px] xl:rounded-b-[200px] h-[827px] bg-[#F8F8F8]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col items-center">
                <p className="merriweather font-[700] italic text-[32px] xl:text-[50px] mt-[40px] xl:mt-[56px] tex text-center xl:text-start">{t('home.1')}</p>
                <p className="xl:max-w-[487px] inter text-center fdfd mt-[20px] xl:mt-[26px]"><Trans>{t('home.2')}</Trans></p>
                <Button className={"mt-[40px] xl:mt-[26px]"}/>
                <div className="xl:w-[1220px] relative hidden xl:block">
                    <div className="absolute left-0 flex flex-col gap-[35px]">
                        <div className="flex flex-col gap-[10px]">
                            <p className="merriweather italic font-[700] text-[30px]">{t('home.4')}</p>
                            <p className="inter font-[300] text-[16px]">{t('home.5')}</p>
                        </div>
                        <div className="flex flex-col gap-[10px]">
                            <p className="merriweather italic font-[700] text-[30px]"><CountUp end={1000} duration={2} separator="," />+</p>
                            <p className="inter font-[300] text-[16px]">{t('home.6')}</p>
                        </div>
                        <div className="flex flex-col gap-[10px]">
                            <p className="merriweather italic font-[700] text-[30px]">$<CountUp end={12348463} duration={3} separator="," /></p>
                            <p className="inter font-[300] text-[16px]">{t('home.7')}</p>
                        </div>
                    </div>
                    <div className="absolute right-0 flex flex-col items-end gap-[35px]">
                        <div className="flex flex-col gap-[10px] items-end">
                            <p className="merriweather italic font-[700] text-[30px]">24/7</p>
                            <p className="inter font-[300] text-[16px]">{t('home.8')}</p>
                        </div>
                        <div className="flex flex-col gap-[10px] items-end">
                            <p className="merriweather italic font-[700] text-[30px]"><CountUp end={91000} duration={2.5} separator="," /></p>
                            <p className="inter font-[300] text-[16px]">{t('home.9')}</p>
                        </div>
                        <div className="flex flex-col gap-[10px] items-end">
                            <p className="merriweather italic font-[700] text-[30px]">{t('home.10')}</p>
                            <p className="inter font-[300] text-[16px]">{t('home.11')}</p>
                        </div>
                    </div>
                </div>
                <div className="bg-main-circle w-[769px] h-[769px] rounded-full mt-[55px] circle-animation"></div>
                <Fade bottom delay={700}><img src={gif} className="absolute bottom-0 xl:w-[500px]" alt="" /></Fade>
            </div>
        </div>
    );
}

export default Main;